module.exports = __webpack_public_path__ + "img/denmark.4be3bf33.svg";